import { render, staticRenderFns } from "./Restricted.vue?vue&type=template&id=3ca43e37&"
import script from "./Restricted.vue?vue&type=script&lang=ts&"
export * from "./Restricted.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports